import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream-50 font-sans text-slate-800 selection:bg-sage-200 selection:text-sage-900" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Services data-id="element-5" />
        <Pricing data-id="element-6" />
        <Team data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CallToAction data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}